module.exports = __webpack_public_path__ + "media/2.c1e017b6.mp3";